import { SpoolDto } from '../../../../../../types/spool-local';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import CollapsibleArea from '../../../../../components/CollapsibleArea';
import { TableRow } from '../../../../../components/Table';
import { TabsContext } from '../../../../../components/Tabs';
import appContext from '../../../../../context/app/appContext';
import useIsMounted from '../../../../../hooks/useIsMounted';
import SpoolCreatorFeesAccordionContent from './SpoolCreatorFeesAccordionContent';
import SpoolCreatorFeesAccordionRow from './SpoolCreatorFeesAccordionRow';

type Props = {
    spoolDetails: SpoolDto;
    collapsed: boolean;
    toggle: () => void;
};

const SpoolCreatorFeesAccordion: React.FC<Props> = ({
    spoolDetails,
    collapsed,
    toggle,
}) => {
    const { setSelectedSpool } = useContext(appContext);

    const { updateHeight } = useContext(TabsContext);

    const [disabled, setDisabled] = useState(false);

    const isMounted = useIsMounted();

    const handleToggle = useCallback(() => {
        if (disabled) return;

        toggle();
        setDisabled(true);
        setSelectedSpool(spoolDetails);
    }, [disabled, spoolDetails, toggle, setSelectedSpool]);

    useEffect(() => {
        updateHeight();

        const timeout = setTimeout(() => {
            isMounted() && setDisabled(false);
        }, 1000);

        return () => {
            clearTimeout(timeout);
        };
    }, [collapsed, updateHeight, isMounted]);

    return (
        <TableRow className={collapsed ? 'collapsed' : ''}>
            <SpoolCreatorFeesAccordionRow
                spoolDetails={spoolDetails}
                toggle={handleToggle}
            />
            <CollapsibleArea
                unMountOnExit
                className='spool-creator-fees-accordion-content'
                collapsed={collapsed}
            >
                <SpoolCreatorFeesAccordionContent
                    collapsed={collapsed}
                    spoolDetails={spoolDetails}
                />
            </CollapsibleArea>
        </TableRow>
    );
};

export default SpoolCreatorFeesAccordion;
